import React, { FC } from 'react'
import { Spacing } from 'Pages/landings/newLandings/common/style'
import { LayoutComponent } from 'Pages/landings/newLandings/common/Layout'
import { BannerComponent } from 'Pages/landings/newLandings/acquiring/Banner'
import { AdvantagesComponent } from 'Pages/landings/newLandings/acquiring/Advantages'
import { ForOutletComponent } from 'Pages/landings/newLandings/acquiring/ForOutlet'
import { ForCouriersComponent } from 'Pages/landings/newLandings/acquiring/ForCouriers'
import { BenefitsComponent } from 'Pages/landings/newLandings/acquiring/Benefits'
import { AdvantagesPayoutComponent } from 'Pages/landings/newLandings/acquiring/AdvantagesPayout'
import { ManageAccountComponent } from 'Pages/landings/newLandings/acquiring/ManageAccount'
import { ProcedureComponent } from 'Pages/landings/newLandings/acquiring/Procedure'
import { FormComponent } from 'Pages/landings/newLandings/acquiring/Form'
import { ContactsComponent } from 'Pages/landings/newLandings/acquiring/Contacts'
import { CookieHandlingNotice } from 'Pages/landings/newLandings/common/components'

const LandingSalaryProject: FC = () => (
	<LayoutComponent title="Эквайринг" menuButton="form">
		<Spacing height="24px" heightLX="32px" />
		<BannerComponent />
		<Spacing height="64px" heightLX="80px" />
		<AdvantagesComponent />
		<Spacing height="88px" heightLX="104px" />
		<ForOutletComponent />
		<Spacing height="88px" heightLX="104px" />
		<ForCouriersComponent />
		<Spacing height="88px" heightLX="104px" />
		<BenefitsComponent />
		<Spacing height="88px" heightLX="104px" />
		<AdvantagesPayoutComponent />
		<Spacing height="88px" heightLX="104px" />
		<ManageAccountComponent />
		<Spacing height="88px" heightLX="104px" />
		<ProcedureComponent />
		<Spacing height="88px" heightLX="104px" />
		<FormComponent />
		<Spacing height="88px" heightLX="104px" />
		<ContactsComponent />
		<Spacing height="104px" heightLX="120px" />
		<CookieHandlingNotice />
	</LayoutComponent>
)
export default LandingSalaryProject
